import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Camera, Mic, Wifi, CheckCircle, XCircle } from 'lucide-react'

export function VerificacaoTecnicaPage() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()

  const [camera, setCamera] = useState<'pending' | 'ok' | 'error'>('pending')
  const [microfone, setMicrofone] = useState<'pending' | 'ok' | 'error'>('pending')
  const [conexao, setConexao] = useState<'pending' | 'ok' | 'error'>('pending')

  useEffect(() => {
    async function verificar() {
      // Verificar câmera
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true })
        stream.getTracks().forEach(t => t.stop())
        setCamera('ok')
      } catch {
        setCamera('error')
      }

      // Verificar microfone
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        stream.getTracks().forEach(t => t.stop())
        setMicrofone('ok')
      } catch {
        setMicrofone('error')
      }

      // Verificar conexão
      if (navigator.onLine) {
        setConexao('ok')
      } else {
        setConexao('error')
      }
    }

    verificar()
  }, [])

  const todosOk = camera === 'ok' && microfone === 'ok' && conexao === 'ok'

  function getIcon(status: string) {
    if (status === 'ok') return <CheckCircle className="h-6 w-6 text-green-500" />
    if (status === 'error') return <XCircle className="h-6 w-6 text-red-500" />
    return <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="space-y-6 p-6">
          <h1 className="text-center text-xl font-semibold">Verificação Técnica</h1>
          <p className="text-center text-sm text-muted-foreground">
            Precisamos verificar seu dispositivo antes da consulta.
          </p>

          <div className="space-y-4">
            <div className="flex items-center gap-4 rounded-lg border p-4">
              <Camera className="h-8 w-8 text-primary" />
              <div className="flex-1">
                <p className="font-medium">Câmera</p>
                <p className="text-sm text-muted-foreground">
                  {camera === 'pending' ? 'Verificando...' : camera === 'ok' ? 'Funcionando' : 'Não disponível'}
                </p>
              </div>
              {getIcon(camera)}
            </div>

            <div className="flex items-center gap-4 rounded-lg border p-4">
              <Mic className="h-8 w-8 text-primary" />
              <div className="flex-1">
                <p className="font-medium">Microfone</p>
                <p className="text-sm text-muted-foreground">
                  {microfone === 'pending' ? 'Verificando...' : microfone === 'ok' ? 'Funcionando' : 'Não disponível'}
                </p>
              </div>
              {getIcon(microfone)}
            </div>

            <div className="flex items-center gap-4 rounded-lg border p-4">
              <Wifi className="h-8 w-8 text-primary" />
              <div className="flex-1">
                <p className="font-medium">Conexão</p>
                <p className="text-sm text-muted-foreground">
                  {conexao === 'pending' ? 'Verificando...' : conexao === 'ok' ? 'Conectado' : 'Sem conexão'}
                </p>
              </div>
              {getIcon(conexao)}
            </div>
          </div>

          <Button
            className="w-full"
            disabled={!todosOk}
            onClick={() => navigate(`/teleconsulta/${token}/espera`)}
          >
            {todosOk ? 'Continuar para Sala de Espera' : 'Aguardando verificações...'}
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
